import React from "react";

import { ColorPhaseScore as ColorPhaseScoreComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface ColorPhaseScoreProps {
    subDimensionData?: any;
}

const ColorPhaseScore: React.FC<ColorPhaseScoreProps> = ({ subDimensionData }) => {
    const { colorPhaseScoreData, isFetchingColorPhaseScore, isErrorColorPhaseScore } =
        useSessionDetailsContext();

    const isEmptyState =
        !colorPhaseScoreData ||
        colorPhaseScoreData?.length === 0 ||
        colorPhaseScoreData === null ||
        colorPhaseScoreData?.dataset?.length === 0;

    if (isFetchingColorPhaseScore) {
        return <ContentLoader height="28.078125rem" />;
    }

    if (isEmptyState) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:color-phase-score:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="25.125rem"
                />
            </ComponentWrapper>
        );
    }

    if (isErrorColorPhaseScore && !isFetchingColorPhaseScore) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="25.125rem"
                />
            </ComponentWrapper>
        );
    }

    return (
        <ColorPhaseScoreComponent
            data={subDimensionData ? subDimensionData : colorPhaseScoreData}
        />
    );
};

export default ColorPhaseScore;
